(() => {
  'use strict';

  const config = window.BrillianThemeLicense;
  if (!config || !config.endpoint || !config.key || !config.shop) return;

  const RETRY_MS = 60000;
  const TIMEOUT_MS = 8000;
  const explicitInvalidReasons = new Set([
    'inactive',
    'expired',
    'not_found',
    'missing_parameters',
    'invalid_callback'
  ]);

  let requestInFlight = false;
  let requestCounter = 0;

  function removeRemoteLock() {
    document.documentElement.dataset.brLicense = 'valid';
    document.getElementById('BrLicenseRemoteStyle')?.remove();
    document.getElementById('BrLicenseRemoteLock')?.remove();
  }

  function lockStore(reason) {
    document.documentElement.dataset.brLicense = 'invalid';

    if (!document.getElementById('BrLicenseRemoteStyle')) {
      const style = document.createElement('style');
      style.id = 'BrLicenseRemoteStyle';
      style.textContent = `
        html[data-br-license="invalid"],
        html[data-br-license="invalid"] body {
          min-height: 100%;
          overflow: hidden !important;
          background: #f7f6f3 !important;
        }

        html[data-br-license="invalid"] body > :not(.br-license-lock) {
          display: none !important;
        }

        .br-license-lock {
          position: fixed;
          z-index: 2147483647;
          inset: 0;
          display: grid;
          place-items: center;
          padding: 24px;
          background: #f7f6f3;
          color: #303030;
          font-family: Arial, sans-serif;
          text-align: center;
        }

        .br-license-lock__panel {
          width: min(100%, 420px);
          padding: 32px 28px;
          border: 1px solid rgba(48, 48, 48, .14);
          border-radius: 14px;
          background: #fff;
        }

        .br-license-lock strong {
          display: block;
          margin-bottom: 8px;
          font-size: 20px;
        }

        .br-license-lock p {
          margin: 0;
          color: #68645f;
          font-size: 14px;
          line-height: 1.55;
        }
      `;
      document.head.appendChild(style);
    }

    if (!document.getElementById('BrLicenseRemoteLock')) {
      const lock = document.createElement('div');
      lock.id = 'BrLicenseRemoteLock';
      lock.className = 'br-license-lock';
      lock.setAttribute('role', 'alert');
      lock.dataset.reason = reason || 'invalid';
      lock.innerHTML =
        '<div class="br-license-lock__panel">' +
          '<strong>Tema lisansı doğrulanamadı</strong>' +
          '<p>Bu tema kullanılan mağaza için lisanslanmamış veya lisansı devre dışı bırakılmıştır.</p>' +
        '</div>';
      document.body.appendChild(lock);
    }
  }

  function validateLicense() {
    if (requestInFlight) return;
    requestInFlight = true;
    requestCounter += 1;

    const callbackName =
      '__brLicenseCb' + Date.now().toString(36) + requestCounter.toString(36);
    const script = document.createElement('script');
    let finished = false;

    const cleanup = () => {
      if (finished) return;
      finished = true;
      requestInFlight = false;
      window.clearTimeout(timeoutId);
      script.remove();
      try {
        delete window[callbackName];
      } catch (error) {
        window[callbackName] = undefined;
      }
    };

    window[callbackName] = (result) => {
      const response = result || {};

      if (response.valid === true) {
        removeRemoteLock();
      } else if (explicitInvalidReasons.has(String(response.reason || ''))) {
        lockStore(String(response.reason || 'invalid'));
      } else {
        document.documentElement.dataset.brLicense = 'verification-error';
      }

      cleanup();
    };

    const params = new URLSearchParams({
      callback: callbackName,
      key: String(config.key).trim(),
      shop: String(config.shop).trim().toLowerCase(),
      _: String(Date.now())
    });

    script.async = true;
    script.src = String(config.endpoint) + '?' + params.toString();
    script.onerror = () => {
      document.documentElement.dataset.brLicense = 'verification-error';
      cleanup();
    };

    const timeoutId = window.setTimeout(() => {
      document.documentElement.dataset.brLicense = 'verification-error';
      cleanup();
    }, TIMEOUT_MS);

    document.head.appendChild(script);
  }

  validateLicense();
  window.setInterval(validateLicense, RETRY_MS);
  window.addEventListener('focus', validateLicense);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) validateLicense();
  });
})();
